<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="show"
      variant="transparent"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      no-wrap
    />
  </div>
</template>

<script>
import { BOverlay } from 'bootstrap-vue'

export default {
  name: 'Spinner',
  components: {
    BOverlay,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },

}
</script>
